import { Platform } from "react-native";

import { getExpoSecureStoreItemAsync } from "@whoosh/utilities/src/ExpoSecureStore/expoSecureStore";

export const getFiltersFromStorage = async (key: string) => {
  if (key.length) {
    const safeKey = key.replace(/[^a-zA-Z0-9]/g, "");
    try {
      if (Platform.OS !== "web") {
        return await getExpoSecureStoreItemAsync(safeKey);
      } else {
        const data = localStorage.getItem(safeKey);
        if (data === null) {
          return localStorage.getItem(key); // I need to do this for backwards compatibility.
        }
        return data;
      }
    } catch (error) {
      return null;
    }
  } else {
    return null;
  }
};
